import { jsxs as u, jsx as o } from "react/jsx-runtime";
import * as r from "@radix-ui/react-scroll-area";
import { forwardRef as h } from "react";
const b = {
  position: "relative",
  overflow: "hidden"
}, m = {
  width: "100%",
  height: "100%",
  borderRadius: "inherit"
}, l = {
  display: "flex",
  userSelect: "none",
  touchAction: "none",
  padding: 2,
  background: "transparent",
  transition: "background var(--duration-medium) var(--ease-out)"
}, t = {
  flex: 1,
  background: "var(--border-strong)",
  borderRadius: "var(--radius-pill)",
  position: "relative"
}, f = h(
  function({ orientation: e = "vertical", children: a, className: n, style: i, viewportClassName: s, ...c }, d) {
    return /* @__PURE__ */ u(
      r.Root,
      {
        ref: d,
        className: ["ls-scroll-area", n].filter(Boolean).join(" "),
        style: { ...b, ...i },
        ...c,
        children: [
          /* @__PURE__ */ o(
            r.Viewport,
            {
              className: ["ls-scroll-viewport", s].filter(Boolean).join(" "),
              style: m,
              children: a
            }
          ),
          e !== "horizontal" ? /* @__PURE__ */ o(
            r.Scrollbar,
            {
              orientation: "vertical",
              style: { ...l, width: 8 },
              children: /* @__PURE__ */ o(r.Thumb, { style: t })
            }
          ) : null,
          e !== "vertical" ? /* @__PURE__ */ o(
            r.Scrollbar,
            {
              orientation: "horizontal",
              style: { ...l, height: 8, flexDirection: "column" },
              children: /* @__PURE__ */ o(r.Thumb, { style: t })
            }
          ) : null,
          /* @__PURE__ */ o(r.Corner, { style: { background: "transparent" } })
        ]
      }
    );
  }
), y = r.Root, w = r.Viewport, A = r.Scrollbar, g = r.Thumb, x = r.Corner;
export {
  f as S,
  x as a,
  y as b,
  A as c,
  g as d,
  w as e
};
//# sourceMappingURL=ScrollArea-BE3owCA_.js.map
